import { render, staticRenderFns } from "./TaskTypeDetails.vue?vue&type=template&id=3c38b0f4"
import script from "./TaskTypeDetails.vue?vue&type=script&lang=js"
export * from "./TaskTypeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports